// extracted by mini-css-extract-plugin
module.exports = {"group":"ContextMenu_group_pJutw","button":"ContextMenu_button_12wCg"};